var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGavelClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 133,
    viewBox: "0 0 185 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_3037_55459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4093 43.1639L57.2339 73.519L77.5193 73.5936L77.6947 43.2385L57.4093 43.1639Z",
    fill: "#BA7121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4292 43.4202L71.2485 73.7753L77.4936 73.7993L77.6742 43.4442L71.4292 43.4202Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3827 46.7751L57.3618 50.3904L77.6472 50.465L77.6681 46.8497L57.3827 46.7751Z",
    fill: "#52ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2788 65.8244L57.2573 69.4397L77.5427 69.5178L77.5642 65.9026L57.2788 65.8244Z",
    fill: "#FF892A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8155 42.9767C79.8064 44.2904 78.7367 45.3535 77.4222 45.3472L57.6491 45.2761C56.3346 45.2698 55.2731 44.203 55.2821 42.8893C55.2912 41.5756 56.3608 40.5125 57.6753 40.5188L77.4528 40.5957C78.7673 40.602 79.823 41.6732 79.8198 42.9825L79.8155 42.9767Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4532 40.5958L77.3804 40.5958C77.5412 40.9203 77.6408 41.2724 77.6369 41.6565C77.6279 42.9702 76.5582 44.0333 75.2437 44.027L55.539 43.9501C55.9258 44.7227 56.7149 45.2671 57.6451 45.2704L77.4183 45.3415C78.7328 45.3478 79.8024 44.2847 79.8115 42.971C79.8205 41.6573 78.759 40.5905 77.4445 40.5842L77.4532 40.5958Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6358 73.607C79.6267 74.9207 78.5527 75.978 77.2425 75.9775L57.4694 75.9064C56.1549 75.9001 55.0934 74.8333 55.1024 73.5196C55.1115 72.2058 56.1811 71.1427 57.4957 71.149L77.2731 71.226C78.5876 71.2323 79.6492 72.2991 79.6401 73.6128L79.6358 73.607Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5145 71.2451C77.6941 71.5827 77.8053 71.9624 77.7985 72.3669C77.7953 73.6762 76.7256 74.7393 75.4052 74.7374L55.638 74.6619C55.555 74.6604 55.4793 74.6444 55.3978 74.6327C55.7934 75.3806 56.5666 75.8916 57.4764 75.8919L77.2496 75.963C78.5641 75.9693 79.6338 74.9062 79.6428 73.5925C79.6502 72.3617 78.7195 71.3605 77.5218 71.2305L77.5145 71.2451Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.853 53.686C143.049 54.1044 144.813 56.3425 144.801 58.5394C144.788 60.7362 142.993 62.9585 140.793 63.3607C113.183 67.6251 105.509 58.3608 77.8995 62.6252C75.6989 63.0274 73.9335 60.472 73.9462 58.2752C73.9589 56.0784 75.7528 53.5389 77.9499 53.947C105.511 58.4233 113.287 49.2141 140.853 53.686Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.855 54.0166C142.094 54.5913 142.234 55.2039 142.229 55.8062C142.217 58.003 140.422 60.2253 138.227 60.6232C110.618 64.8876 102.944 55.6232 75.3282 59.892C74.9437 59.9617 74.5726 59.9397 74.2176 59.8421C74.7973 61.5052 76.2131 62.9242 77.8952 62.6193C105.505 58.3549 113.179 67.6192 140.789 63.3549C142.989 62.9527 144.784 60.7303 144.796 58.5335C144.805 56.6844 143.56 54.8115 141.855 54.0166Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8208 55.3822C91.8291 54.3958 92.6302 53.6061 93.6128 53.6065C94.5998 53.6126 95.3883 54.4116 95.3859 55.3937L95.3481 61.3032C95.3398 62.2896 94.5387 63.0793 93.5561 63.0789C92.5691 63.0728 91.7806 62.2738 91.783 61.2918L91.815 55.3866L91.8208 55.3822Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.425 53.8162L94.3751 62.8843C94.9538 62.5877 95.3512 62.0001 95.3587 61.3046L95.3965 55.3951C95.3982 54.704 95.0066 54.1074 94.4309 53.8119L94.425 53.8162Z",
    fill: "#9B622F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9665 75.9999H45.1572V86.83H84.9665V75.9999Z",
    fill: "#C4833B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.124 89.1777C90.124 91.0748 88.587 92.6084 86.6857 92.6084H43.4382C41.537 92.6084 40 91.0748 40 89.1777C40 87.2806 41.537 85.7469 43.4382 85.7469H86.6857C88.587 85.7469 90.124 87.2806 90.124 89.1777Z",
    fill: "#9B622F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3037_55459",
    x: 0,
    y: 0.518799,
    width: 184.801,
    height: 132.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3037_55459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3037_55459",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavelClosed);
export default __webpack_public_path__ + "static/media/gavel-closed.caed05cf671d0f6856c8fdf189663c67.svg";
export { ForwardRef as ReactComponent };